module.exports = __webpack_public_path__ + "done-bbcf6a4f58eb654374eb2c6260a13ca6.svg";